import React, { useState } from "react";
import MaterialTable from "material-table";
import Cookies from "universal-cookie";
import { config } from "../services/config";

// COMPONENTS 
import AddActivities from "./addActivities/AddActivities.component";

// SERVICES 
import {deleteActivitiesImage} from "../services/activities/Activities";
import EditActivities from "./editActivities/EditActivities.component";

// COOKIE
const cookies = new Cookies();

const token = cookies.get("browser_ID");



const ActivitiesPage = () => {
  const [activitiesEdit, setActivitiesEdit] = useState();  
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };


  return (
    <div className="dashboard-container">
      <div className="dashboard">
        <div style={{ position: "relative", zIndex: 0 }}>
          <a href="#add">
            <div className="table-addbutton text-rumpel">
              ADD
            </div>
          </a>
          <MaterialTable
            columns={[
              { title: "Title", field: "title" },
              { title: "Description", field: "description" }
            ]}
            data={query =>
              new Promise((resolve, reject) => {
                fetch(config.activities + `/${query.pageSize}`, {
                  method: "GET",
                  headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                  }
                })
                  .then(response => response.json())
                  .then(result => {
                    if (result.success || result.success === false) {
                      resolve({
                        data: result.data.data,
                        page: query.page,
                        totalCount: result.data.total
                      });
                    } else {
                      reject(console.log("error"));
                    }
                  });
              })
            }
            editable={{
              onRowDelete: oldData =>
                new Promise((resolve, reject) => {
                  fetch(config.deleteActivities + oldData.id, {
                    method: "DELETE",
                    headers: {
                      Accept: "application/json",
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${token}`
                    }
                  })
                    .then(response => response.json())
                    .then(result => {
                      if (result.success) {
                        resolve();
                      } else {
                        reject(console.log("error"));
                      }
                    });
                }),
            }}
            actions={[
              {
                icon: "edit",
                tooltip: "Edit",
                onClick: (event, rowData) => {
                  setActivitiesEdit(rowData)
                  handleClickOpen()
                  // document.getElementById('add-article').scrollIntoView()
    
                  // props.history.push("/our-work/", {
                  //   editData: rowData
                  // });
                }
              }
            ]}
            detailPanel={rowData => {
              const deleteHandler = async (id) =>{
                let deleteImageResponse = await deleteActivitiesImage(id);
                if(deleteImageResponse.data.success===true){
                  window.document.location.reload()
              }
                
              }
              return (
                <div
                  style={{
                    padding: 20,
                    display: "grid",
                    gridTemplateColumns: "repeat(9, 1fr)"
                  }}
                >
                  {rowData.images &&
                    rowData.images.map((item, index) => {
                      return (
                        // <img width="100" height="100" style={{marginRight: 10}} alt="images" src={item.image}/>
                        <div
                          style={{
                            position: "relative",
                            backgroundImage: `url(${item.image})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            gridTemplateColumns: "1fr",
                            height: 100,
                            width: 100
                          }}
                        >
                          <div
                            style={{
                              position: "absolute",
                              top: 0,
                              right: 10,
                              color: "red",
                              cursor: "pointer",
                              fontSize: 20
                            }}
                            className="font-averta text-bold"
                            onClick={() => deleteHandler(item.id)}
                          >
                            x
                          </div>
                        </div>
                      );
                    })}
                </div>
              );
            }}
            title="Activities"
            options={{
              actionsColumnIndex: -1,
              emptyRowsWhenPaging: false,
              search: false
            }}
          />
        </div>
        <div id="add" style = {{paddingTop: 150}}>
            {/* ADD HERE  */}
            <AddActivities />
        </div>
        <EditActivities activitiesValue={activitiesEdit} openStatus={open} onCloseClick={handleClose} />
      </div>
    </div>
  );
};

export default ActivitiesPage;
